import { socialApiClient } from '@/shared/api-client/social-api-client';
import { exportToCSV } from '@/shared/utils/export-to-csv';

export const ExportExcludedCreatorList = async (workspace_id: string, signal?: AbortSignal) => {
  const res = await socialApiClient.post(`creators/exclude-list/export`, {
    json: {
      workspace_id: workspace_id,
    },
    signal,
  });
  const text = await res.text();
  exportToCSV(text, 'exclude-list.csv');
};
